// PrivateRoute.js
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate } from "react-router-dom"; // Navigate importeren
import { auth } from "../firebase"; // Firebase auth importeren
import "./home.css";

const PrivateRoute = ({ element }) => {
  const [user, loading, error] = useAuthState(auth); // Controleer of de gebruiker is ingelogd

  if (loading) {
    return (
      <>
        <div className="loading-message">
          <div className="pagename">Loading...</div>
        </div>
      </>
    );
  } // Laadstatus afhandelen (bijvoorbeeld een laadspinner of een andere indicatie)

  if (error) {
    console.error("Authenticatie fout:", error);
  }

  // Als de gebruiker niet ingelogd is, wordt hij doorgestuurd naar de loginpagina
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return element; // Return de gerenderde element als gebruiker is ingelogd
};

export default PrivateRoute;
